export default "__VITE_ASSET__1c8619ac__"